<form [formGroup]="accountFeatureSwitchFormGroup" autoTrackUnsavedChanges>
  <div class="p-grid" style="align-items: center;">
    <div class="p-col-2">
      <label for="account-budget-update-active" class="field-input-label tab-input-label">Automate Google Ads Account Budget
        <span class="pi pi-info-circle"
          pTooltip="If enabled, MPOP will update the Google Ads account budget each day based on the sum of the account's standard, boost, and heavy-up budgets from Salesforce. This feature requires that Google Ads is active."
        tooltipPosition="top"></span></label>
      </div>
      <div class="p-col-4">
        <p-toggleswitch
          formControlName="updateAccountBudget"
          id="account-budget-update-active">
        </p-toggleswitch>
      </div>
      <div class="p-col-2">
        <label for="campaign-budgets-update-active" class="field-input-label tab-input-label">Automate Google Ads Campaign Budgets
          <span class="pi pi-info-circle"
            pTooltip="If enabled, MPOP will update the account’s Google Ads campaign and shared budgets each day based on the configured budget allocation below and the campaign or shared budget’s current spend pacing for the month."
          tooltipPosition="top"></span></label>
        </div>
        <div class="p-col-4">
          <p-toggleswitch
            formControlName="updateCampaignBudget"
            id="campaign-budgets-update-active">
          </p-toggleswitch>
        </div>
        <div class="p-col-2">
          <label class="field-input-label tab-input-label">Account Budget</label>
        </div>
        <div class="p-col-4">
          ${{stringFormatterService.formatNumberToString(accountBudget)}}
        </div>
        <div class="p-col-2">
          <label class="field-input-label tab-input-label">Last Updated</label>
        </div>
        <div class="p-col-4">
          @if (googleAdsCampaignBudgetsLastUpdated === null) {
            <label class="field-input-label tab-input-label">Never</label>
          }
          {{googleAdsCampaignBudgetsLastUpdated | date:'shortDate'}}
        </div>
        <div class="p-col-2">
          <label class="field-input-label tab-input-label">Last Updated</label>
        </div>
        <div class="p-col-4">
          @if (googleAdsAccountBudgetLastUpdated === null) {
            <label class="field-input-label tab-input-label">Never</label>
          }
          {{googleAdsAccountBudgetLastUpdated | date:'shortDate'}}
        </div>
        <div class="p-col-2">
          <button pButton
            id="featureToggleSaveButton"
            class="p-button-success"
            pTooltip="Saves the settings for both the Account and Campaign Budget toggles"
            (click)="saveFeatures()"
            label="Save">
          </button>
        </div>
      </div>
    </form>
<p-tabs [value]="0">
  <p-tablist>
    <p-tab [value]="0">Standard Budgets</p-tab>
    <p-tab [value]="1">Heavy-Up Budgets</p-tab>
  </p-tablist>
  <p-tabpanels>
    <p-tabpanel [value]="0">
      <auto-budget-template
        [accountId] = "accountId"
        [expandIcon]="expandIcon"
        [collapseIcon]="collapseIcon"
        [activeBudgetManagements]="standardActiveBudgetManagements"
        [pendingBudgetManagements]="standardPendingBudgetManagements"
        [budgetType]="standardBudget">
      </auto-budget-template>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <auto-budget-template
        [accountId] = "accountId"
        [expandIcon]="expandIcon"
        [collapseIcon]="collapseIcon"
        [activeBudgetManagements]="heavyUpActiveBudgetManagements"
        [pendingBudgetManagements]="heavyUpPendingBudgetManagements"
        [budgetType]="heavyUpBudget">
      </auto-budget-template>
    </p-tabpanel>
  </p-tabpanels>
</p-tabs>
